import { render } from "./SystemBadge.vue?vue&type=template&id=96e3f3e0&scoped=true"
import script from "./SystemBadge.vue?vue&type=script&lang=js"
export * from "./SystemBadge.vue?vue&type=script&lang=js"

import "./SystemBadge.vue?vue&type=style&index=0&id=96e3f3e0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96e3f3e0"]])

export default __exports__